module.exports = __webpack_public_path__ + "img/receivedXF.651d7cb2.png";